let itemCheckbox = document.querySelectorAll('.js-item-checkbox');
let checkedAllItems = document.querySelector('.js-checked-all');
let itemsCount = document.querySelector('.js-items-count');

function updateItemsCount() {
  let selectedCount = Array.from(itemCheckbox).filter(el => el.checked).length;
  itemsCount.textContent = selectedCount;
}

checkedAllItems.addEventListener('change', function() {
  let isChecked = checkedAllItems.checked;
  itemCheckbox.forEach(function(el) {
    el.checked = isChecked;
  });
  updateItemsCount();
});

itemCheckbox.forEach(function(el) {
  el.addEventListener('change', function() {
    if (!el.checked) {
      checkedAllItems.checked = false;
    } else {
      let allChecked = Array.from(itemCheckbox).every(item => item.checked);
      checkedAllItems.checked = allChecked;
    }
    updateItemsCount();
  });
});

updateItemsCount();
